<mat-card appearance="outlined" class="card">
  <mat-card-title i18n="@@serviceTeam"> Chain Admins </mat-card-title>
  <section>
    <article>
      <mat-card-actions>
        <div class="flex-row start-center gap-20">
          <button
            type="submit"
            matButton="elevated"
            color="primary"
            (click)="onAddAdmin()"
          >
            <mat-icon>add</mat-icon>
            <span i18n>New Chain Admin</span>
          </button>
          <button matButton="elevated" (click)="onBack()">
            <mat-icon>arrow_back</mat-icon>
            <span i18n>Back</span>
          </button>
        </div>
      </mat-card-actions>
      <mat-card-content>
        <app-admins-list [admins$]="admins$"
          [adminType]="adminType"
          (adminSelected)="onAdminSelected($event)"
         />
      </mat-card-content>
    </article>
    <article>
      @if ( selectedAdmin; as admin) {
      <div class="app-selected-box">
        <div class="flex-row space-between-center" style="font-weight: bold">
          {{ admin.name }}
          <button
            matIconButton
            matSuffix
            aria-label="Clear"
            (click)="clearSelection()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="app-info-label" i18n="@@email">email</div>
        <div class="app-info-data">{{ admin.email }}</div>
        <div class="app-info-label" i18n="@@phone">phone</div>
        <div class="app-info-data">{{ admin.phone }}</div>
        <div class="app-info-label" i18n="@@chains">Chains</div>
        @if (!editChain) {
        <div class="flex-row space-between-center">
            <div class="app-info-data" style="flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
              {{ admin?.chains?.length > 0 ? getChainNames(admin) : "-" }}
            </div>
            <mat-icon (click)="onEditChains()" style="flex-shrink: 0; margin-left: 8px; cursor: pointer;">edit</mat-icon>
        </div>

        } @if (editChain) {
        <div class="flex-row start-center gap-20">
          <mat-form-field style="flex: 1 0 45%">
            <mat-label i18n="@@selectChain">Select Chain</mat-label>
            <mat-select [(ngModel)]="selectedChainUuids" multiple>
              <!--                  <mat-option [value]=null>-&#45;&#45;</mat-option>-->
              @for (chain of chains ; track chain) {
              <mat-option [value]="chain.uuid">{{ chain.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div>
            <mat-icon class="app-icon-btn" (click)="saveChain()">save</mat-icon>
            <mat-icon class="app-icon-btn" (click)="closeEdit()"
              >cancel</mat-icon
            >
          </div>
        </div>
        }
        <div class="app-info-label" i18n="@@password">Password</div>
        <form [formGroup]="form">
          @if (!resettingPassword) {
          <div class="flex-row end-center">
            <button
              style="flex: 0 1 50%"
              matButton="outlined"
              color="primary"
              (click)="resettingPassword = true"
              i18n
            >
              Reset Password
            </button>
          </div>
          } @if (resettingPassword) {
          <mat-checkbox
            class="app-check-box"
            (change)="setManualPassword()"
            formControlName="manualPassword"
            i18n
          >
            Set password manually
          </mat-checkbox>
          @if (form.get('manualPassword').value) {
          <div class="flex-row space-between-center">
            <mat-form-field>
              <input
                matInput
                placeholder="Password"
                [type]="hidePass ? 'password' : 'text'"
                formControlName="password"
                required
              />
              <mat-icon matSuffix (click)="hidePass = !hidePass">{{
                hidePass ? "visibility_off" : "visibility"
              }}</mat-icon>
            </mat-form-field>
            <div style="font-size: xx-small">
              @if (form.get('password').hasError('required')) {
              <mat-error i18n> Please enter new password </mat-error>
              } @if (form.get('password').hasError('minlength')) {
              <mat-error i18n>
                - Password must contain min 6 characters
              </mat-error>
              } @if (form.get('password').hasError('pattern')) {
              <mat-error i18n>
                - Password must contain one upper character and one digit
              </mat-error>
              }
            </div>
          </div>
          }
          <!--              <mat-checkbox class="app-check-box"-->
          <!--                            formControlName="forceLogout" i18n> Force logout from all devices-->
          <!--              </mat-checkbox>-->
          <div class="flex-row space-between-center">
            @if (form.get('manualPassword').value) {
            <button
              matButton="outlined"
              color="primary"
              (click)="resetPassword(admin.uuid)"
            >
              <mat-icon>vpn_key</mat-icon>
              <span i18n> Set new password manually </span>
            </button>
            } @if (!form.get('manualPassword').value) {
            <button
              matButton="outlined"
              color="primary"
              [disabled]="form.invalid"
              (click)="resetPassword(admin.uuid)"
            >
              <mat-icon>forward_to_inbox</mat-icon>
              <span i18n> Send e-mail resetting password </span>
            </button>
            }
            <mat-icon class="app-icon-btn" (click)="closeResetForm()"
              >cancel</mat-icon
            >
          </div>
          }
        </form>
      </div>
      }
    </article>
  </section>
</mat-card>
